// TEAMS Website - HomePage Component
// Main page with snap-scroll sections

import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import HeroSection from '../components/sections/HeroSection.jsx';
import MissionAboutSection from '../components/sections/MissionAboutSection.jsx';
import ActivitiesSection from '../components/sections/ActivitiesSection.jsx';
import CarnegieHallSection from '../components/sections/CarnegieHallSection.jsx';
import VenuesSection from '../components/sections/VenuesSection.jsx';
//import PressSection from '../components/sections/PressSection.jsx';
import BookingSection from '../components/sections/BookingSection.jsx';
import '../styles/main.scss';

const HomePage = () => {
  const { t } = useTranslation();
  const [isScrolling, setIsScrolling] = useState(false);
  const [touchStart, setTouchStart] = useState(0);
  const [currentSection, setCurrentSection] = useState(0);
  const containerRef = useRef(null);

  // Section definitions
  const sections = [
    { id: 'hero', title: 'Introduction' },
    { id: 'mission', title: 'Mission & Vision' },
    { id: 'activities', title: 'Activities' },
    { id: 'carnegie', title: 'Carnegie Hall' },
    { id: 'venues', title: 'Venues' },
  //  { id: 'press', title: 'Press & Media' },
    { id: 'booking', title: 'Get in Touch' }
  ];

  // Enhanced scroll handler with better UX
  const scrollToSection = (sectionIndex, smooth = true) => {
    const targetSection = document.getElementById(sections[sectionIndex].id);
    if (!targetSection) return;
    
    // Immediately update the active section when clicking
    setCurrentSection(sectionIndex);
    
    setIsScrolling(true);
    targetSection.scrollIntoView({
      behavior: smooth ? 'smooth' : 'auto',
      block: 'start'
    });
    
    setTimeout(() => setIsScrolling(false), smooth ? 1000 : 0);
  };

  // Handle scroll to update current section
  useEffect(() => {
    const handleScroll = () => {
      if (isScrolling) return;

      const sectionElements = sections.map(section => 
        document.getElementById(section.id)
      );
      
      const scrollPosition = window.scrollY + 100; // 100px from top for better detection
      let activeIndex = 0;
      
      // Find which section is currently in view
      for (let i = sectionElements.length - 1; i >= 0; i--) {
        const element = sectionElements[i];
        if (element && element.offsetTop <= scrollPosition) {
          activeIndex = i;
          break;
        }
      }
      
      // Only update if different to prevent unnecessary re-renders
      if (activeIndex !== currentSection) {
        setCurrentSection(activeIndex);
      }
    };

    // Initial check on mount
    handleScroll();
    
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isScrolling, sections.length, currentSection]);

  return (
    <div className="home-page">
      {/* Navigation Dots */}
      <div className="presentation-nav">
        <div className="presentation-nav__dots">
          {sections.map((section, index) => (
            <button
              key={index}
              className={`presentation-nav__dot ${currentSection === index ? 'active' : ''}`}
              onClick={() => scrollToSection(index)}
              aria-label={`Go to section ${index + 1}: ${section.title}`}
            >
              <span className="presentation-nav__dot-number">{index + 1}</span>
            </button>
          ))}
        </div>
        <div className="presentation-nav__info">
          <span className="presentation-nav__current">{currentSection + 1}</span>
          <span className="presentation-nav__separator">/</span>
          <span className="presentation-nav__total">{sections.length}</span>
        </div>
      </div>

      {/* Hero Section */}
      <section id="hero">
        <HeroSection />
      </section>

      {/* Section Divider */}
      <div className="section-divider" />

      {/* Mission & Who We Are Section */}
      <section id="mission" >
        <MissionAboutSection />
      </section>

      {/* Section Divider */}
      <div className="section-divider" />

      {/* Activities Section */}
      <section id="activities" >
        <ActivitiesSection />
      </section>

      {/* Section Divider */}
      <div className="section-divider" />

      {/* Carnegie Hall Section */}
      <section id="carnegie" >
        <CarnegieHallSection />
      </section>
      {/* Events Section 
      <section id="events" >
        <EventsSection />
      </section>
      */}
      {/* Section Divider */}
      <div className="section-divider" />

      {/* Venues Section */}
      <section id="venues" >
        <VenuesSection />
      </section>

      {/* Section Divider */}
      <div className="section-divider" />

      {/* Press & Media Section 
      <section id="press" >
        <PressSection />
      </section>

      <div className="section-divider" />
      */}

      {/* Booking Section */}
      <section id="booking" >
        <BookingSection />
      </section>

      </div>
  );
};

export default HomePage;
